module.exports = __webpack_public_path__ + "img/sceptic.b031b67e.png";